import { PermissionEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { Button } from '@hyperflake/react-ui-library';
import ProjectInstallationList from 'modules/project-installation/components/ProjectInstallationList/ProjectInstallationList';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { Link, useNavigate, useParams } from 'react-router-dom';

const PeojectInstallationPage = () => {
    const { hasPermission } = useAuthPermission();
    const { clientInstallationId } = useParams();
    const navigate = useNavigate();
    return (
        <PageTemplate>
            <div className="flex justify-between">
                <PageHeading>Project Installations</PageHeading>

                {hasPermission(PermissionEnum.PROJECT_INSTALLATION_CREATE) && (
                    // <Button onClick={addClientDialog.show}>Add Client</Button>
                    <Link to={`/client-installations/${clientInstallationId}/project-installations/add`}>
                        <Button
                            onClick={() =>
                                navigate(`/client-installations/${clientInstallationId}/project-installations/add`)
                            }
                        >
                            Add Project
                        </Button>
                    </Link>
                )}
            </div>
            <ProjectInstallationList />
        </PageTemplate>
    );
};

export default PeojectInstallationPage;
